// Centralized copy for onboarding step titles and subtitles.
// Indexed by currentStep, where index 0 corresponds to the role selection step.

export const ONBOARDING_TITLES = {
  carrier: [
    "Basic Information",
    "Authority Information",
    "Review & Finish",
  ],
};

export const ONBOARDING_SUBTITLES = {
  carrier: [
    "Tell us about your business",
    "Enter your DOT number",
    "Review your information before completing",
  ],
};


